var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_792_11842)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D92D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.364 16.6967C28.6569 16.4038 28.6569 15.9289 28.364 15.636C28.0711 15.3431 27.5962 15.3431 27.3033 15.636L28.364 16.6967ZM15.636 27.3033C15.3431 27.5962 15.3431 28.0711 15.636 28.364C15.9289 28.6569 16.4038 28.6569 16.6967 28.364L15.636 27.3033ZM27.3033 28.364C27.5962 28.6569 28.0711 28.6569 28.364 28.364C28.6569 28.0711 28.6569 27.5962 28.364 27.3033L27.3033 28.364ZM16.6967 15.636C16.4038 15.3431 15.9289 15.3431 15.636 15.636C15.3431 15.9289 15.3431 16.4038 15.636 16.6967L16.6967 15.636ZM37.75 22C37.75 30.6985 30.6985 37.75 22 37.75V39.25C31.5269 39.25 39.25 31.5269 39.25 22H37.75ZM22 37.75C13.3015 37.75 6.25 30.6985 6.25 22H4.75C4.75 31.5269 12.4731 39.25 22 39.25V37.75ZM6.25 22C6.25 13.3015 13.3015 6.25 22 6.25V4.75C12.4731 4.75 4.75 12.4731 4.75 22H6.25ZM22 6.25C30.6985 6.25 37.75 13.3015 37.75 22H39.25C39.25 12.4731 31.5269 4.75 22 4.75V6.25ZM27.3033 15.636L21.4697 21.4697L22.5303 22.5303L28.364 16.6967L27.3033 15.636ZM21.4697 21.4697L15.636 27.3033L16.6967 28.364L22.5303 22.5303L21.4697 21.4697ZM28.364 27.3033L22.5303 21.4697L21.4697 22.5303L27.3033 28.364L28.364 27.3033ZM22.5303 21.4697L16.6967 15.636L15.636 16.6967L21.4697 22.5303L22.5303 21.4697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_792_11842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_Error.7a32a376194640482cffeff5eaeb614d.svg";
export { ForwardRef as ReactComponent };